import React from "react"
import { Link } from "react-router-dom"
import Back from "../common/back/Back"
import "./features.css"

const points = [
  { icon: "fa fa-chart-line",    text: "Live chart analysis using real market data — not textbook examples." },
  { icon: "fa fa-shield-alt",    text: "Risk-first approach: capital preservation before profit-chasing." },
  { icon: "fa fa-cogs",          text: "Technology-based tools and platforms used by professional traders." },
  { icon: "fa fa-graduation-cap",text: "Beginner-friendly curriculum that scales to advanced strategy." },
  { icon: "fa fa-laptop",        text: "Accessible via mobile and desktop — learn from anywhere." },
  { icon: "fa fa-users",         text: "Small classes ensure every student gets individual attention." },
]

const markets = [
  { icon: "fa fa-dollar-sign", label: "Forex", desc: "Major, minor, and exotic currency pairs." },
  { icon: "fa fa-chart-bar",   label: "Futures", desc: "Commodity and financial futures contracts." },
  { icon: "fa fa-exchange-alt",label: "Options", desc: "Call and put options strategies." },
  { icon: "fa fa-globe",       label: "Indices", desc: "S&P 500, NASDAQ, FTSE, and more." },
  { icon: "fa fa-coins",       label: "Commodities", desc: "Gold, oil, and agricultural markets." },
  { icon: "fa fa-file-contract",label: "CFDs", desc: "Contracts for difference on all major assets." },
]

const PracticalTrading = () => (
  <>
    <Back title="Practical Trading Education" />

    <section className="feature-page padding">
      <div className="container">

        {/* Hero intro */}
        <div className="feature-intro">
          <div className="feature-intro-icon">
            <i className="fa fa-chart-line"></i>
          </div>
          <div className="feature-intro-text">
            <p className="feature-eyebrow">WHY ROVERS ACCESS</p>
            <h2>The Edge That Makes the Difference</h2>
            <p>
              Our second-to-none competitive practical and technology-based programme provides
              our students with an edge over self-taught traders. We believe <strong>gambling is
              not trading</strong> — and we build the knowledge that separates the two.
            </p>
            <p>
              Unlike traditional academic finance courses, Rovers Access focuses on
              <strong> applied market knowledge</strong>: students learn to read live charts,
              manage real risk, and execute trades across forex, commodities, indices, and CFDs
              from day one.
            </p>
          </div>
        </div>

        {/* Key points */}
        <div className="feature-section">
          <h3 className="feature-section-title"><i className="fa fa-star"></i> What Makes Us Different</h3>
          <div className="feature-points-grid">
            {points.map((p, i) => (
              <div className="feature-point" key={i}>
                <div className="feature-point-icon"><i className={p.icon}></i></div>
                <p>{p.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Markets covered */}
        <div className="feature-section">
          <h3 className="feature-section-title"><i className="fa fa-globe"></i> Markets We Cover</h3>
          <div className="feature-markets-grid">
            {markets.map((m, i) => (
              <div className="feature-market-card" key={i}>
                <div className="market-icon"><i className={m.icon}></i></div>
                <h4>{m.label}</h4>
                <p>{m.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Who it's for */}
        <div className="feature-section feature-cta-section">
          <h3>Ready to trade with a real edge?</h3>
          <p>
            Whether you're a complete beginner or a self-taught trader who's struggling with
            consistency — our practical programme is designed to give you the structure,
            knowledge, and confidence you need.
          </p>
          <div className="feature-cta-btns">
            <Link to="/courses" className="feature-btn primary">
              <i className="fa fa-graduation-cap"></i> View Our Courses
            </Link>
            <a href="https://wa.me/254723000200" target="_blank" rel="noreferrer" className="feature-btn whatsapp">
              <i className="fab fa-whatsapp"></i> Chat with Us
            </a>
          </div>
        </div>

      </div>
    </section>
  </>
)

export default PracticalTrading
